import React from "react";

const ImageGrid = ({ props }) => {
  const { name } = props;

  return (
    <div>
      <h1 className="headline">{name}</h1>
    </div>
  );
};

export default ImageGrid;
